import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@daynote/shared-types';

export type AppMode = 'local' | 'cloud';

interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  mode: AppMode; // 'cloud' = 登录态走服务端；'local' = 免登录本地模式
  setAuth: (user: User, accessToken: string, refreshToken: string) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setUser: (user: User) => void;
  enterLocalMode: () => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      mode: 'local',
      setAuth: (user, accessToken, refreshToken) =>
        set({ user, accessToken, refreshToken, mode: 'cloud' }),
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setUser: (user) => set({ user }),
      enterLocalMode: () => set({ mode: 'local' }),
      // 登出回到本地模式；本地数据(IndexedDB)不受影响
      logout: () =>
        set({ user: null, accessToken: null, refreshToken: null, mode: 'local' }),
    }),
    {
      name: 'daynote-auth',
      // 兼容旧持久化：有 token 的老用户视为云端
      onRehydrateStorage: () => (state) => {
        if (state?.accessToken) state.mode = 'cloud';
      },
    },
  ),
);
